<template>
    <div class="-container-fluid -align-self-start">

       <!-- {{  props.filter }} -->

    <div class="row">
        <div class="col-6">
            <div class="d-block"><span>Client:</span></div>
            <client-ac 
                inputclass="form-control" 
                v-model="filter.client"
            ></client-ac>
        </div>
        <div class="col-6">
            <kt-input 
                label="Start Date" 
                type="date" 
                v-model="filter.startDate"
            ></kt-input>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-6">
            <job-select 
                :client="filter.client" 
                v-model="filter.job"
            ></job-select>
        </div>
        <div class="col-6">
            <kt-input 
                label="End Date" 
                type="date" 
                v-model="filter.endDate"
            ></kt-input>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-6">
            <tech-select 
                @change="" 
                v-model="filter.user"
                active="1"
            ></tech-select>
        </div>
        <div class="col-6">
            <div class="-p-1">
                <div><span>Date Range:</span></div>
                <div class="input-group">
                    <select v-model="dateRange" class="form-control" @change="setDateRange(dateRange)">
                        <option value="">Choose Date Range</option>
                        <option value="Today">Today</option>
                        <option value="Yesterday">Yesterday</option>
                        <option value="This Week">This Week</option>
                        <option value="Last Week">Last Week</option>
                        <option value="This Month">This Month</option>
                        <option value="Last Month">Last Month</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" v-if="!props.mode">
        <div class="col-6">
            <div class="-p-1">
                <div><span>Type:</span></div>
                <div class="input-group">
                    <select class="form-control" v-model="filter.type">
                        <option value="work">Work</option>
                        <option value="task">Tech Task</option>
                        <!--
                        <option value="pto">PTO</option>
                        <option value="holiday">Holiday</option>
                        -->
                    </select>
                </div>
            </div>
        </div>
    </div>
    <!-- 
    <div class="row mt-3">
        <div class="col-6"><button class="form-control btn btn-sm btn-primary"> Set Filter </button></div>
        <div class="col-6">
            <div class="dropdown"><button class="form-control btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Show Report </button>
                <ul class="dropdown-menu end-0" aria-labelledby="dropdownMenuButton1">
                    <li><a class="dropdown-item" href="#"><span>Time Report (PDF)</span></a></li>
                    <li><a class="dropdown-item" href="#"><span>Actual Work</span></a></li>
                    <li><a class="dropdown-item" href="#"><span>Actual Work (PDF)</span></a></li>
                    <li><a class="dropdown-item" href="#"><span>Get Import Code (SQL)</span></a></li>
                </ul>
            </div>
        </div>
    </div>
    -->

    <div class="row mt-3">
        <div class="col-4">
            <button class="form-control btn btn-outline-secondary" @click="$emit('dismiss')">
                Cancel
            </button>
        </div>
        <div class="col-4">
            <button class="form-control btn btn-outline-warning" @click="clear()">
                Clear
            </button>
        </div>
        <div class="col-4">
            <button class="form-control btn btn-outline-primary" @click="setFilter()">
                Set Filter
            </button>
        </div>
    </div>

</div>
</template>


<script lang="ts" setup>

import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Helper, { DateRange, DateFormat} from "@/services/Helper";
import ClientAc from "@/components/Clients/ClientAc.vue";
import JobSelect from "@/components/Jobs/JobSelect.vue";
import TechSelect from "@/components/Techs/TechSelect.vue";
import KtInput from "@/components/UI/KtInput.vue";

const route = useRoute();
const router = useRouter();

const emits = defineEmits([
    "update", "dismiss", 
]);

const props = defineProps({
    filter: {
        type: Object,
        default: {
            client: "",
            job: "",
            user: "",
            type: "work",
            status: "",
            startDate: "",
            endDate: "",
            page: "",
        }
    },
    
    mode: 
    {
        type: String,
        default: ""
    }
});

const getNewFilter = () =>
{
    return {
        client: "",
        job: "",
        user: "",
        type: "work",
        startDate: "",
        endDate: "",
        page: "",
    };
};

const dateRange = ref("");
const filter = ref(getNewFilter());

watch(() =>
{
    return JSON.stringify(props.filter);
}, 
(nv, ov) => 
{
    if (nv) 
    {
        filter.value = props.filter;
    }
}, { immediate: true })


// TODO - convert into utility function
const setDateRange = (type:string) =>
{
    let range:DateRange = DateRange.Today;
    switch (type)
    {
        case "Today":
            range = DateRange.Today;
            break;

        case "Yesterday":
            range = DateRange.Yesterday;
            break;

        case "This Week":
            range = DateRange.This_Week;
            break;

        case "Last Week":
            range = DateRange.Last_Week;
            break;

        case "This Month":
            range = DateRange.This_Month;
            break;

        case "Last Month":
            range = DateRange.Last_Month
    }

    let ret = Helper.getDateRange(range);
    filter.value.startDate = ret[0];
    filter.value.endDate = ret[1];

    dateRange.value = "";
};

const setFilter = () =>
{
    // STORE FILTER IN THE CACHE ...
    
    // make sure the page is 0 ...
    filter.value.page = 0;

    let flt = Helper.toUrlParams(filter.value);
    emits("update", flt);
    emits("dismiss");
};

const clear = () =>
{
    // keep the type ...
    let type = filter.value.type;
    filter.value = getNewFilter();
    filter.value.type = type;
};

onMounted(() =>
{
    // PULL FROM THE URL FILTER
    if (!filter.value.type) {
        filter.value.type = "work";
    }
});

</script>